import { y as f } from "./trackerReferenceLifecycle-xEM9DpA6.js";
function p(n) {
  let e;
  try {
    e = f.load(n);
  } catch (t) {
    const r = t instanceof f.YAMLException ? t.reason || t.message : String(t);
    return { ok: !1, error: `Not valid YAML${t instanceof f.YAMLException && t.mark ? ` (line ${t.mark.line + 1})` : ""}: ${r}` };
  }
  return e == null ? { ok: !0, value: {} } : typeof e != "object" || Array.isArray(e) ? { ok: !1, error: 'Expected "key: value" lines.' } : { ok: !0, value: e };
}
function b(n, e) {
  const t = Object.entries(e).map(([l, a]) => [l, typeof a == "number" ? Math.round(a) : a]), r = (l) => typeof l == "number" ? String(l) : f.dump(l, { lineWidth: -1 }).trimEnd();
  let i = n.split(`
`);
  const o = [];
  for (const [l, a] of t) {
    const d = new RegExp(`^${l}\\s*:`), u = i.findIndex((m) => d.test(m));
    a === null ? u >= 0 && (i = i.filter((m, h) => h !== u)) : u >= 0 ? i[u] = `${l}: ${r(a)}` : o.push(`${l}: ${r(a)}`);
  }
  const s = [...o, ...i].join(`
`), c = p(s);
  if (!c.ok) return n;
  for (const [l, a] of t)
    if ((c.value[l] ?? null) !== a) return n;
  return s;
}
function y(n) {
  const e = x(n).filter((r) => r.some((i) => i.trim() !== ""));
  if (e.length === 0) return [];
  const t = e[0].map((r) => r.trim());
  return e.slice(1).map((r) => {
    const i = {};
    return t.forEach((o, s) => {
      if (!o) return;
      const c = (r[s] ?? "").trim();
      i[o] = c !== "" && Number.isFinite(Number(c)) ? Number(c) : c;
    }), i;
  });
}
function x(n) {
  const e = [];
  let t = [], r = "", i = !1;
  for (let o = 0; o < n.length; o += 1) {
    const s = n[o];
    i ? s === '"' && n[o + 1] === '"' ? (r += '"', o += 1) : s === '"' ? i = !1 : r += s : s === '"' && r.trim() === "" ? (i = !0, r = "") : s === "," ? (t.push(r), r = "") : s === `
` || s === "\r" ? (s === "\r" && n[o + 1] === `
` && (o += 1), t.push(r), e.push(t), t = [], r = "") : r += s;
  }
  return t.push(r), e.push(t), e;
}
const g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseFenceCsv: y,
  parseFenceYaml: p,
  setFenceYamlValues: b
}, Symbol.toStringTag, { value: "Module" }));
function M(n) {
  if (n.length === 0) return { min: 0, max: 1 };
  const e = Math.min(0, ...n), t = Math.max(1, ...n);
  return { min: e, max: t === e ? e + 1 : t };
}
function N(n, e) {
  const t = (n - e.min) / (e.max - e.min);
  return Math.min(1, Math.max(0, t));
}
function $(n) {
  if (typeof n == "number") return Number.isFinite(n) ? n : null;
  if (typeof n == "string" && n.trim() !== "") {
    const e = Number(n.trim());
    return Number.isFinite(e) ? e : null;
  }
  return null;
}
export {
  N as a,
  y as b,
  $ as c,
  g as f,
  p,
  M as q,
  b as s
};
//# sourceMappingURL=quadrantModel-qMpAvFjw.js.map
